<template>
  <div class="cut-detail">
    <div class="video">
      <div class="container">
        <!-- @canplay="handleCanPlay" -->
        <video preload="auto" controls controlslist="nodownload noplaybackrate" :showCenterPlayBtn="false"
          :disablePictureInPicture="true" playsinline="true" webkit-playsinline="true"
          :src="templateDetail.videoUrl || templateDetail.templateUrl" ref="video" @pause="isPlaying = false"
          x5-video-player-type="h5" @play="isPlaying = true" @end="isPlaying = false" crossorigin="anonymous"
          :poster="templateDetail.coverUrl" :style="{ width: '100%', height: '100%', objectFit: 'contain' }"></video>

        <!-- <img v-if="!isPlaying" src="/images/sameStyle/template_play.png" @click.stop="playVideo" /> -->
      </div>
    </div>

    <div class="footer">
      <div class="tabs">
        <div v-for="(item, index) in tabs" :key="index" :class="{ active: index === activeTab }">
          <span @click="chooseTab(index)">{{ item.title }}</span>

          <template v-if="index === activeTab">
            <img class="bottom" src="/images/sameStyle/checked.png" />
            <img class="star" src="/images/sameStyle/start.png" />
          </template>

        </div>
      </div>

      <div class="upload-container">

        <div class="slot-list">
          <!-- 可能是图片可能是视频 -->
          <template v-if="templateType === 'image'">
            <div v-for="(item, index) in templateDetail.materialList" :key="index" :class="{
              'slot-item': true,
              'img-item': true,
            }" :style="{ backgroundImage: item.resourceUrl ? `url(${item.resourceUrl})` : 'none' }">
              <div class="bardge">{{ index + 1 }}</div>
              <img v-if="!item.resourceUrl" class="add-icon" @click="handleAddFile(index)"
                src="/images/sameStyle/addFile.png" />

              <img v-if="item.resourceUrl" class="del-file" @click="handleDelFile(index)"
                src="/images/sameStyle/del-file.png" />
            </div>
          </template>

          <template v-else>
            <div v-for="(item, index) in templateDetail.materialList" :key="index" :class="{
              'slot-item': true,
              'img-item': true
            }" :style="{ backgroundImage: videoToPicList[index] ? `url(${videoToPicList[index]})` : 'none' }">
              <div class="bardge">{{ index + 1 }}</div>
              <img v-if="!item.resourceUrl" class="add-icon" @click="handleAddFile(index)"
                src="/images/sameStyle/addFile.png" />

              <img v-if="item.resourceUrl" class="del-file" @click="handleDelFile(index)"
                src="/images/sameStyle/del-file.png" />

              <!-- 视频已上传 -->
              <div v-if="item.resourceUrl" class="mask">
                <span>{{ item | handleSeconds }}s</span>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="tips">{{ templateDetail | handleText(templateType) }}</div>

      <div class="btn">
        <div @click="handleCompose">合成视频</div>
      </div>
    </div>

    <input class="hide" type="file" ref="uploadInput" :multiple="multiple" @change="choosedFile" :accept="accept"
      @click="beforeChoose" />

    <SameStyleDialog :show="showDialog" @close="showDialog = false">
      <template v-if="dialogType == 'loading'">
        <div slot="container" class="loading">
          <img src="/images/sameStyle/loading.png" />
          <div class="title">{{ loadingText }}</div>
          <div class="loading-tips">请不要退出小程序或离开此页面</div>
        </div>
      </template>

      <template v-if="dialogType == 'authorization'">
        <div slot="title" class="download-title">提示</div>

        <div slot="container">
          <div class="tips-text">相册权限未开启，无法获取本机素材。您需要允许魔音工坊调用您的全部相册权限</div>
        </div>

        <div slot="operator" class="operator">
          <div class="quit" @click="showDialog = false">取消</div>
          <div class="confirm" @click="showDialog = false">去开启</div>
        </div>
      </template>
    </SameStyleDialog>


    <!---test 以下部分放入到模版详情页面-->
    <!-- 发音人弹窗部分 start -->
    <fesitval-speaker-popup ref="festivalSpeakerRef" :visible="speakerVisible" :speaker-info="speakerInfo"
      @close="speakerVisible = false" @change-speaker="changeSpeaker"></fesitval-speaker-popup>
    <!-- 发音人弹窗部分 end -->
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { judgeDeviceType } from "@/utils/device";
import SameStyleDialog from '@/components/sameStyle-dialog/Dialog.vue'
import { toast } from '@/utils/util'
import FesitvalSpeakerPopup from '../sameStyle/components/fesitvalSpeakerPopup/fesitvalSpeakerPopup.vue';
import axios from 'axios'
import { getQueryString } from "@/utils/location";
import apis from '../order/store/apis';
import moment from "moment";
import { resolve } from 'path';


@Component({
  components: { SameStyleDialog, FesitvalSpeakerPopup },
  computed: {
    accept() {
      return this.templateType === 'image' ? 'image/*' : 'video/mp4'
    },
    tabs() {
      return [
        {
          title: this.templateType === 'image' ? '上传图片' : '上传视频'
        }, {
          title: '选择配音'
        }
      ]
    }
  },
  filters: {
    handleText(info, type) {
      const { materialCount } = info

      if (!materialCount) return ''

      return type === 'image' ? `需要上传 ${materialCount} 张图片～` : `需要上传 ${materialCount} 个视频～`
    },
    handleSeconds(info) {
      return Math.floor((info.endTime - info.startTime) / 1000)
    }
  },
  data() {
    return {
      ww_token: '',
      id: '',
      type: '',
      productId: null,
      templateId: null,
      currentTime: 0,
      templateDetail: {
        materialCount: 0,
        materialList: []
      },
      templateType: 'image',
      videoToPicList: [],

      isAPP: judgeDeviceType.isAPP,
      iosAuthorization: false,
      showDialog: false,
      dialogType: '',
      loadingText: '照片上传中…',
      acceptFileItems: [],

      isPlaying: false,
      activeTab: 0,
      multiple: true,
      speakerVisible: false, // 发音人弹窗是否显示
      speakerInfo: {},//当前发音人
      speakerName: '',
      ttToken: ''
    }
  },
  created() {
    // 获取详情
    this.ww_token = getQueryString('ww_token')
    this.id = getQueryString('id')
    this.type = getQueryString('type')
    this.templateId = getQueryString('templateId')
    this.env = getQueryString('platform');
    // this.getDetail()
    this.currentTime = moment().format('YYYYMMDDHHmmss')
    let platform = getQueryString('platform');
    if (platform) {
      localStorage.setItem('platform', platform)
    }

  },
  mounted() {
    window.isContinueUpload = this.isContinueUpload;

    if (this.type === 'template') {
      this.getDetail()
    } else if (this.type === 'product') {
      this.getProductDetail()
    }
    // this.speakerInfo = this.curSpeakerAudio;
  },
  watch: {//使用3秒克隆的用TA配音进入该页面路由后面会加参数
    $route: {
      handler() {
        let query = this.$route.query;
        //使用3秒克隆的声音 -3秒克隆声音不支持根据关键字查询 只能将整个声音需要的数据输入,有taskId代表是克隆的声音
        if (query.speakerTokenId) {
          let { speakerTokenId, speakerHeadImg, speakerName, taskId } = query;
          let currSpeakerInfo = {
            speaker: speakerTokenId,
            speakerName: speakerName,
            name: speakerName,//为了跟普通发音人同步 添加了该name字段
            style: '默认',
            taskId: taskId,
            headerImage: speakerHeadImg
          };
          this.changeSpeaker(currSpeakerInfo);
          //修改子组件的发音人信息-默认使用该发音人
          this.$refs.festivalSpeakerRef.setCurrentSpeaker(currSpeakerInfo);
          //从3秒克隆的用TA配音进入,需要清空上一次的已选发音人currentClickSpeakerId
          //(因为新的克隆的声音作为默认发音人templateSpeaker传入,选中状态默认先比对currentClickSpeakerId
          //,则会选中上一次的发音人)
          //this.$refs.festivalSpeakerRef.$refs.searchSpeakerRef.$refs.speakerCards.clearCurrentClickSpeaker()
          this.$bus.$emit('clearCurrentClickSpeaker')
        };
      }
    },
    templateDetail: {
      handler(val) {
        if (this.templateType !== 'image') {
          this.handleVideoToPic(val.materialList)
        }
      },
      deep: true
    }
  },
  methods: {
    getDetail() {
      axios.get(`/apis/tts-web-api/template/video/template/detail?id=${this.id}&ww_token=${this.ww_token}`).then(res => {
        if (res.data.code !== 200) return toast(res.data.message);
        this.templateDetail = res.data.data

        document.title = this.templateDetail.title
        let { speaker, speakerName, speed, style } = this.templateDetail;
        this.speakerInfo.speaker = speaker;
        this.speakerInfo.speakerName = speakerName;
        this.speakerInfo.speed = speed;
        this.speakerInfo.style = style || '默认';
        // 判断素材类型
        const { materialList = [] } = this.templateDetail
        if (materialList.length > 0) {
          this.templateType = materialList[0].type

          // 获取TTToken
          if (this.env === 'tt' && this.templateType === 'image') this.getTTToken()
        }
      })
    },

    getProductDetail() {
      axios.get(`/apis/tts-web-api/template/video/detail?id=${this.id}&ww_token=${this.ww_token}`).then(res => {
        if (res.data.code !== 200) return toast(res.data.message);

        this.templateDetail = res.data.data
        this.productId = this.templateDetail.id
        document.title = this.templateDetail.title
        let { speaker, speakerName, speed, style } = this.templateDetail;
        this.speakerInfo.speaker = speaker;
        this.speakerInfo.speakerName = speakerName;
        this.speakerInfo.speed = speed;
        this.speakerInfo.style = style || '默认';
        // 判断素材类型
        const { materialList = [] } = this.templateDetail
        if (materialList.length > 0) {
          this.templateType = materialList[0].type

          // 获取TTToken
          if (this.env === 'tt' && this.templateType === 'image') this.getTTToken()
        }
      })
    },
    // handleCanPlay(){
    // },
    handleVideoClick() {
      this.isPlaying ? this.pauseVideo() : this.playVideo()

      if (!this.isPlaying) {
        this.$refs.video.focus()
      }
    },
    playVideo() {
      this.$refs.video.play()
      this.isPlaying = true
    },
    pauseVideo() {
      this.$refs.video.pause()
      this.isPlaying = false
    },
    handleClick() {
      !this.isPlaying && this.playVideo()
    },
    handleCompose() {
      // 判断素材是否上传完整
      let isNotAllUpload = this.templateDetail.materialList.find(item => !item.resourceUrl)

      if (isNotAllUpload) return toast('请上传全部素材再点击合成')

      this.showDialog = true
      this.dialogType = 'loading'
      this.loadingText = '视频合成中…'


      this.handleComposeRequest()
    },
    handleAddFile(index) {
      // 判断是否可以上传多个，已经上传的文件类型
      let currentNum = 0
      let acceptFileItems = []
      this.templateDetail.materialList.forEach((item, i) => {
        if (i >= index && !item.resourceUrl) {
          currentNum++
          acceptFileItems.push(i)
        }
      });

      this.acceptFileItems = acceptFileItems
      this.multiple = currentNum > 1
      this.acceptFileNum = currentNum
      this.$nextTick(() => {
        this.$refs.uploadInput.click();
      })
    },
    beforeChoose(e) {
      // this.dialogType = 'loading'
      // this.showDialog = true
      if (this.isAPP && !this.iosAuthorization) {
        this.showDialog = true
        this.dialogType = 'authorization'
        e.preventDefault();
        // 弹出授权弹窗
        toast('请先授权使用相册')
      }
    },
    async choosedFile(e) {
      let files = []
      // 判断当前上传的文件数量和需要的文件数量
      Array.from(e.target.files).forEach((item, index) => {
        if (index < this.acceptFileNum) {
          files.push(item)

          let fileType = item.name.slice(item.name.lastIndexOf('.') + 1).toLocaleUpperCase();

          if (this.templateType !== 'image' && (fileType != "MP4" && fileType != 'MOV')) {
            return toast("请上传mp4格式的视频");
          }

          if (this.templateType === 'image' && !['JPE', 'JPEG', 'JPG', 'PNG', 'GIF'].includes(fileType)) {
            return toast("请上传图片");
          }
        }
      })

      // 执行上传操作
      this.dialogType = 'loading'
      this.showDialog = true

      this.loadingText = this.templateType === 'image' ? '照片上传中…' : '视频上传中...'

      // 执行插入操作
      const promises = [];
      for (let i = 0; i < files.length; i++) {
        const promiseN = this.uploadOneImagFn(files[i]);
        promises.push(promiseN);
      }

      Promise.all(promises).then((filesPath) => {
        this.$refs.uploadInput.value = '';
        // 调用保存视频参数接口
        let materialList = JSON.parse(JSON.stringify(this.templateDetail.materialList))

        let fileIndex = 0
        materialList = materialList.map((val, index) => {
          if (this.acceptFileItems.includes(index)) {
            val.resourceUrl = filesPath[fileIndex]
            fileIndex++
          }
          return val
        })

        this.$set(this.templateDetail, 'materialList', materialList)

        this.saveProductDetail(materialList)
      }).catch(err => {
        this.$refs.uploadInput.value = '';
        this.showDialog = false
      });

    },

    saveProductDetail(materialList) {

      let title = this.type === 'template' ? this.currentTime : this.templateDetail.title
      let bodyData = {
        title,
        templateId: this.templateId || this.id,
        speaker: this.speakerInfo.defaultSpeaker?.speaker || this.templateDetail.speaker,
        speed: this.speakerInfo.speed,
        speakerName: this.speakerInfo.speakerName || this.speakerInfo.name,
        needWatermark: false,
        materialList
      }

      if (this.productId) bodyData.id = this.productId
      axios.post(`/apis/tts-web-api/v1/video/saveVideoParam?id=${this.id}&ww_token=${this.ww_token}`, bodyData).then(res => {
        if (res.data.code !== 200) return toast(res.data.message);
        this.productId = res.data.data.id
        this.showDialog = false
      }).catch(err => {
        this.showDialog = false
        toast(res.data.message);
      })
    },

    handleComposeRequest() {
      let title = this.type === 'template' ? this.currentTime : this.templateDetail.title
      let bodyData = {
        id: this.productId,
        title,
        templateId: this.templateId || this.id,
        speaker: this.speakerInfo.defaultSpeaker?.speaker || this.templateDetail.speaker,
        speed: this.speakerInfo.speed || this.templateDetail.speed,
        speakerName: this.speakerInfo.speakerName || this.speakerInfo.name,
        needWatermark: true,
        materialList: this.templateDetail.materialList
      }

      axios.post(`/apis/tts-web-api/v1/video/composeBeforePreview?id=${this.id}&ww_token=${this.ww_token}`, bodyData).then(res => {
        if (res.data.code !== 200) {
          this.showDialog = false
          return toast(res.data.message);
        }
        // 轮询合成结果
        this.watchComposeSuccess(this.productId)
      })
    },

    watchComposeSuccess(id) {
      axios.get(`/apis/tts-web-api/template/video/status?id=${id}&ww_token=${this.ww_token}`).then(res => {
        // 0-初始化，1-预览成功，2-失败，3-导出，4-导出成功，5-已上传素材
        if (res.data.data == 1 || res.data.data == 4) {
          // 合成成功
          clearTimeout(this.refreshTimer)
          this.showDialog = false
          setTimeout(() => {
            this.$navigateTo({
              url: `/sameStyle-package/pages/compose-result/compose-result?productId=${id}`,
            })
          }, 1000)
        } else if (res.data.data === 2) {
          clearTimeout(this.refreshTimer)
          toast('合成失败');
        } else {
          this.refreshTimer = setTimeout(() => {
            clearTimeout(this.refreshTimer)
            this.watchComposeSuccess(id)
          }, 2000)
        }
      }).catch(err => {
        toast(res.data.message);
      })
    },

    async uploadOneImagFn(file) {
      let formData = new FormData();

      formData.append("file", file)

      let uploadUrl = `/apis/tts-web-api/v1/resources?ww_token=${this.ww_token}`

      return new Promise((resolve, reject) => {
        axios.post(uploadUrl, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 1000 * 60 * 30 // 设置30分钟超时
        }).then(async res => {
          const { ossFile } = res.data.data
          if (this.env === 'tt' && this.templateType === 'image') {
            // 校验图片是否合规
            let moyinCheck = await this.checkimageByMoyinTool(ossFile)
            if(!moyinCheck){
              toast('图片存在风险，请重新上传')
              reject()
            } 
            let checkRes = await this.checkImage(ossFile)
            if (checkRes.error !== 0) {
              toast('图片存在风险，请重新上传')
              reject()
            } else {
              resolve(ossFile);
            }
          } else {
            resolve(ossFile);
          }
        }).catch(err => {
          let tips = this.templateType === 'image' ? '图片上传失败,请稍后再试' : '视频上传失败,请稍后再试'
          this.$refs.uploadInput.value = '';
          toast(tips)
          reject();
        })
      })
    },

    handleDelFile(index) {
      let materialList = JSON.parse(JSON.stringify(this.templateDetail.materialList))

      materialList[index].resourceUrl = null

      this.$set(this.videoToPicList, index, '')

      this.$set(this.templateDetail, 'materialList', materialList)

      this.saveProductDetail(materialList)

    },
    isContinueUpload() {
      this.iosAuthorization = true;
      this.$refs.uploadInput.click();
    },
    chooseTab(index) {
      if (index === 1) {//选择发音人
        this.speakerVisible = true;
      }
    },
    //选择的发音人-最终结果
    changeSpeaker(currSpeakerInfo) {
      this.speakerInfo = currSpeakerInfo;
      //定制声音-克隆和3秒克隆(有taskId) 添加defaultSpeaker字段
      if (currSpeakerInfo.taskId) {
        let defaultSpeaker = { speaker: currSpeakerInfo.speaker, name: currSpeakerInfo.name };
        this.speakerInfo.defaultSpeaker = defaultSpeaker;
      }
    },


    handleVideoToPic(list) {
      const promises = [];
      for (let i = 0; i < list.length; i++) {
        const promiseN = this.getPicByOSSUrl(list[i].resourceUrl);
        promises.push(promiseN);
      }

      Promise.all(promises).then(res => {
        res.forEach((item, index) => {
          if (item !== this.videoToPicList[index]) {
            this.$set(this.videoToPicList, index, item)
          }
        })

      })
    },

    // 通过视频地址获取封面图
    getPicByOSSUrl(url) {
      return new Promise((resolve, reject) => {
        if (url) {
          axios.get(`/apis/tts-web-api/template/video/firstFrame?url=${url}`, {
          }).then(res => {
            resolve(res.data.data);
          }).catch(err => {
            reject('');
          })
        } else {
          resolve('')
        }
      })
    },

    // 获取tttoken
    async getTTToken(refresh = false) {
      let path = '/apis/moyin-tool/tt/accessToken'
      if (refresh) path += '?forceRefresh=true'

      let res = await axios.get(path)
      if (res.data.code !== 200) return toast(res.data.message);
      this.ttToken = res.data.data.token;
    },

    // 校验图片
    async checkImage(url) {
      let res = await axios.post('/tt/checkImage', {
        app_id: 'tt0ff4794990cb256901',
        access_token: this.ttToken,
        image: url
      }, {
        headers: { 'Content-Type': 'application/json' },
      })

      // token失效
      if (res.data.data.error === 2) {
        await this.getTTToken(true)

        await this.checkImage(url)
      } else {
        return res.data.data;
      }
    },

    // moyintool check
    async checkimageByMoyinTool(url){
      let res = await axios.get(`/apis/moyin-tool/image/sensitive/check?url=${url}`)

      if (res.data.code === 200) {
        return true
      } else {
        return false;
      }
    }
  }
})
export default class cutDetail extends Vue { }

</script>

<style lang='less' scoped>
.cut-detail {
  width: 100vw;
  height: 100vh;
  background-color: #FFECEC;
  background-image: url('https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2024-02-04-1302035509534190231.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 40px;
  box-sizing: border-box;

  .video {
    width: calc((9 / 16) * (100vh - 622px) + 52px);
    height: calc(100vh - 574px);
    background-image: url('https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2024-02-04-5017541572650057941.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .container {
      width: calc((9 / 16) * (100vh - 622px));
      height: calc(100vh - 622px);
      border-radius: 32px;
      overflow: hidden;
      position: relative;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 112px;
        height: 112px;
        z-index: 1;
      }

      //全屏按钮
      // video::-webkit-media-controls-fullscreen-button {
      //   display: none;
      // }

      //播放按钮
      // video::-webkit-media-controls-play-button {
      //   display: none;
      // }

      //音量按钮
      // video::-webkit-media-controls-mute-button {
      //   display: none;
      // }

      // video::-webkit-media-controls-toggle-closed-captions-button {
      //   display: none;
      // }

      //音量的控制条
      // video::-webkit-media-controls-volume-slider {
      //   display: none;
      // }

      // video::-webkit-media-controls-overlay-play-button {
      //   display: none;
      // }

      video {
        &:focus {
          outline: -webkit-focus-ring-color auto 0px;
        }
      }
    }
  }

  .footer {
    width: 100vw;
    height: 494px;
    position: absolute;
    left: 0;
    bottom: 0;

    background: #FFFFFF;
    border-radius: 50px 50px 0 0;

    .tabs {
      height: 100px;
      width: 100vw;
      display: flex;
      background-image: url('https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2024-02-04-2762068735737147209.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-color: #EDDBDB;
      border-radius: 50px 50px 0 0;

      >div {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          height: 48px;
          font-size: 32px;
          font-family: HarmonyOS_Sans_SC;
          color: #263446;
        }
      }

      .active {
        position: relative;

        span {
          height: 48px;
          font-size: 32px;
          font-family: HarmonyOS_Sans_SC_Bold;
          color: #001126;
          position: relative;
          z-index: 1;
        }

        .bottom {
          position: absolute;
          left: 50%;
          bottom: 18px;
          transform: translate(-50%, 0);
          width: 188px;
          height: 28px;
        }

        .star {
          position: absolute;
          top: 22px;
          right: 50px;
          width: 26px;
          height: 26px;
        }
      }
    }

    .upload-container {
      width: 100vw;
      background: #FFFFFF;
      box-sizing: border-box;

      .slot-list {
        padding-top: 32px;
        padding-left: 32px;
        box-sizing: border-box;
        width: 100vw;
        overflow: auto;
        display: flex;

        .slot-item {
          flex-shrink: 0;
          position: relative;
          width: 128px;
          height: 128px;
          margin-right: 24px;
          background: #F5F5F7;
          border-radius: 12px;
          background-size: contain;

          .bardge {
            position: absolute;
            top: 0;
            left: 0;
            width: 40px;
            height: 40px;
            background: #001126;
            border-radius: 12px 0px 24px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;
            font-size: 24px;
            font-family: HarmonyOS_Sans_SC_Bold;
            color: #FFFFFF;
          }

          .add-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 32px;
            height: 32px;
          }

          .del-file {
            top: 0;
            right: 0;
            transform: translate(50%, -50%);
            position: absolute;
            width: 32px;
            height: 32px;
            z-index: 1;
          }

          .mask {
            position: absolute;
            background: rgba(0, 0, 0, 0.5);
            width: 100%;
            height: 100%;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              font-size: 28px;
              font-family: HarmonyOS_Sans_SC_Bold;
              color: #FFFFFF;
            }
          }
        }

        .img-item {
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }

        .video-item {
          video {
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;
          }

          .post-img {
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;
            object-fit: contain;
            visibility: hidden;
          }
        }
      }
    }

    .tips {
      margin-top: 8px;
      margin-left: 32px;
      height: 44px;
      font-size: 24px;
      font-family: HarmonyOS_Sans_SC;
      color: #8C949D;
      line-height: 44px;
    }

    .btn {
      box-sizing: border-box;
      padding: 0 32px;
      text-align: center;

      >div {
        margin-top: 16px;
        height: 104px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2024-02-04-6624889749067608705.png');
        background-repeat: no-repeat;
        background-size: contain;

        font-size: 40px;
        // font-family: DOUYINSANSBOLD, DOUYINSANSBOLD;
        font-family: HarmonyOS_Sans_SC_Bold;
        font-weight: normal;
        color: #FFFFFF;
        -webkit-text-stroke: 1px #FE5050;
        text-stroke: 1px #FE5050;
      }
    }
  }

  input {
    display: none;
  }
}
</style>

<style lang="less">
.sameStyle-dialog {
  .loading {
    img {
      width: 104px;
      height: 104px;
      display: block;
      margin: 0 auto;

      animation: spin 1s linear 1s infinite;
    }

    @keyframes spin {
      from {
        -webkit-transform: rotate(0deg);
      }

      to {
        -webkit-transform: rotate(360deg);
      }
    }

    .title {
      height: 56px;
      margin: 48px auto 0;
      width: 472px;
      text-align: center;
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000F1A;
      line-height: 56px;
    }

    .loading-tips {
      margin: 16px auto 0;
      width: 472px;
      height: 48px;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666F76;
      line-height: 48px;
    }
  }

  .download-title {
    height: 56px;
    font-size: 40px;
    font-family: HarmonyOS_Sans_SC_Bold;
    color: #111118;
    line-height: 56px;
    text-align: center;
  }

  .tips-text {
    margin: 32px auto 0;
    width: 472px;
    height: 144px;
    font-size: 32px;
    font-family: HarmonyOS_Sans_SC;
    color: #596472;
    line-height: 48px
  }

  .operator {
    margin: 48px auto 0;
    display: flex;
    justify-content: space-between;

    .quit {
      width: 242px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #F5F6F7;
      border-radius: 40px;
      font-size: 28px;
      font-family: HarmonyOS_Sans_SC;
      color: #001126;
    }

    .confirm {
      width: 242px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FE5050;
      border-radius: 40px;
      font-size: 28px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: #FFFFFF;
    }
  }
}
</style>